import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IssueDevelopmentComponent } from './issue-development.component';
import { DxChartModule, DxTextAreaModule, DxDataGridModule, DxSankeyModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { IssueDevelopmentRoutingModule } from './issue-development-routing.module';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { WebExportModule } from 'src/app/widgets/web-export/web.export.module';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';

@NgModule({
  declarations: [IssueDevelopmentComponent],
  imports: [
    CommonModule,
    DxTableControllerDirective,
    DxChartModule,
    DxTextAreaModule,
    DxDataGridModule,
    DevEpressCommonModule,
    IssueDevelopmentRoutingModule,
    DxSankeyModule, BookmarkModule, WebExportModule,FiltersGroupModule,HelpButtonComponent,BookmarkNewComponent
  ]
})
export class IssueDevelopmentModule { }
